<template>
    <router-link v-if="router && router.name" tag="li" :to="router" :class="isActive()">
        <a  href="#">
            <span>{{ name }}</span>
        </a>
    </router-link>
</template>

<script>

    export default {
        name: "SlidebarSubItem",

        props: {
            type: {
                type: String,
                default: 'item'
            },
            isHeader: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            name: {
                type: String
            },
            active: {
                type: String,
                default: ''
            },
            badge: {
                type: Object,
                default() {
                    return {}
                }
            },
            items: {
                type: Array,
                default() {
                    return []
                }
            },
            router: {
                type: Object,
                default() {
                    return {
                        name: ''
                    }
                }
            },
            link: {
                type: String,
                default: ''
            }
        },
        methods: {
            isActive: function () {
                return (this.router.name == this.$store.state.sidebarsub) ? 'active' : ''
            }
        }

    }
</script>

<style scoped lang="scss">

</style>